/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespPriceTiles_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SbRespTradeFreeShippingPromoTile_viewer">;
    readonly " $refType": "SbRespPriceTiles_viewer";
};
export type SbRespPriceTiles_viewer$data = SbRespPriceTiles_viewer;
export type SbRespPriceTiles_viewer$key = {
    readonly " $data"?: SbRespPriceTiles_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespPriceTiles_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespPriceTiles_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespTradeFreeShippingPromoTile_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '4760440d96086d66ea05dd0069d3c513';
export default node;
